export const toPascalCase = (str) => str.replace(/(\w)(\w*)/g, (g0, g1, g2) => g1.toUpperCase() + g2.toLowerCase());

export const capitalize = (str) => {
  if (str && typeof str === 'string') {
    return str.trim().toLowerCase().replace(/^\w/, (c) => c.toUpperCase());
  }
  return str;
};

export const formatAsPercent = (value) => `${value}%`;

export const formatTwoDigits = (n) => (n < 10 ? '0' : '') + n;
